import { useRef } from 'react';
import { suitColor } from '../../gameEngine';
import CardFace from './CardFace';
import './Card.css';

export default function Card({
  card,
  faceDown = false,
  selected = false,
  disabled = false,
  isNemNew = false,
  isDiscarded = false,
  onTap,
  onDragStart,
  onDragEnd,
  size = 'normal', // 'small' | 'normal' | 'large'
}) {
  const dragRef = useRef(null);
  const touchHandledRef = useRef(false);

  const handleDragStart = (e) => {
    if (disabled || faceDown) return;
    e.dataTransfer.setData('text/plain', JSON.stringify(card));
    e.dataTransfer.effectAllowed = 'move';
    onDragStart?.(card);
  };

  const handleTouchStart = (e) => {
    if (disabled || faceDown) return;
    touchHandledRef.current = false;
    dragRef.current = { card, startX: e.touches[0].clientX, startY: e.touches[0].clientY };
  };

  const handleTouchEnd = (e) => {
    if (disabled || faceDown || !dragRef.current) return;
    const touch = e.changedTouches[0];
    const dx = Math.abs(touch.clientX - dragRef.current.startX);
    const dy = Math.abs(touch.clientY - dragRef.current.startY);
    if (dx < 10 && dy < 10) {
      e.preventDefault();
      touchHandledRef.current = true;
      onTap?.(card);
    }
    dragRef.current = null;
  };

  const handleClick = () => {
    if (disabled || faceDown) return;
    if (touchHandledRef.current) { touchHandledRef.current = false; return; }
    onTap?.(card);
  };

  if (faceDown) {
    return (
      <div className={`card card--face-down card--${size}`}>
        <div className="card__back" />
      </div>
    );
  }

  const color = suitColor(card);
  const classes = [
    'card',
    `card--${size}`,
    `card--${color}`,
    selected && 'card--selected',
    disabled && 'card--disabled',
    isNemNew && 'card--nem-new',
    isDiscarded && 'card--discarded',
  ].filter(Boolean).join(' ');

  return (
    <div
      className={classes}
      draggable={!disabled}
      onDragStart={handleDragStart}
      onDragEnd={onDragEnd}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      onClick={handleClick}
    >
      <CardFace card={card} size={size} />
    </div>
  );
}
